interface SubMenu {
  Menu_Label: string;
  isActive: boolean;
  Menu_URL: string;
  Menu_Icon?: string;
}

interface MenuItem {
  Menu_Label: string;
  isActive: boolean;
  Menu_URL: string;
  Menu_Icon: string;
  subMenu?: SubMenu[];
}

// Direct PowerBI report links (opened in a new browser tab, not embedded via iframe).
export const ENERGY_REPORT_URL =
  'https://app.powerbi.com/reportEmbed?reportId=a4e2d2c4-7195-442c-b6f5-8c507c37bdb6&autoAuth=true&ctid=7370fc8f-4ead-4668-a3a4-ffb467f9374a';

export const MACHINE_ACTIVITY_REPORT_URL =
  'https://app.powerbi.com/reportEmbed?reportId=6d6eb76a-8358-4707-bb26-ded28faec95f&autoAuth=true&ctid=7370fc8f-4ead-4668-a3a4-ffb467f9374a';

// Frontend-only menu item, not returned by the /identity/user/menu backend API.
export const ENERGY_MENU_ITEM: MenuItem = {
  Menu_Label: 'Energy',
  isActive: true,
  Menu_URL: '/energy',
  Menu_Icon: 'energy',
  subMenu: [],
};

export const appendCustomMenuItems = (menu: MenuItem[]): MenuItem[] => {
  const hasEnergyItem = menu.some((item) => item.Menu_URL === ENERGY_MENU_ITEM.Menu_URL);
  return hasEnergyItem ? menu : [...menu, ENERGY_MENU_ITEM];
};
